<script setup lang="ts">
  import { useRoute } from 'vue-router'
  import TheMenuBar from '@/components/the-menu-bar.vue'
  import TheNavbar from '@/components/the-navbar.vue'

  const route = useRoute()
</script>

<template>
  <div>
    <the-navbar v-if="route.name !== 'scan arrival'" />

    <div class="content">
      <router-view />
    </div>

    <the-menu-bar
      v-if="route.name !== 'scan arrival'"
      class="fixed inset-x-0 bottom-0 mx-auto max-w-120" />
  </div>
</template>

<style lang="postcss" scoped>
  .content {
    @apply relative mx-auto max-w-120 min-h-screen bg-white/80 pt-8 -mt-4 pb-20 shadow;
    @apply px-4;
  }
</style>
